import Vue from 'vue';
import Router, { Route } from 'vue-router';
import Home from './views/Home.vue';

import userx from '@/store/modules/userx';

export interface NavigationValidation {
	success: boolean,
	newRoute?: {path: string, query?: any, replace?: boolean},
}

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue'),
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('./views/ForgotPassword.vue'),
    },
    {
      path: '/complete-registration',
      name: 'complete-registration',
      component: () => import('./views/CompleteRegistration.vue'),
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('./views/Auth.vue'),
    },
    {
      path: '/schema',
      name: 'schema',
      component: () => import('./views/SchemaManager.vue'),
    },
    {
      path: '/program',
      name: 'program',
      component: () => import('./views/ProgramManager.vue'),
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('./views/AccountManager.vue'),
    },
    {
      path: '/account/:accountId',
      component: () => import('./views/AccountManager.vue'),
    },
    {
      path: '/gdb/:gdbid',
      name: 'gdb',
      component: () => import('./views/GdbView.vue'),
    },
    {
      path: '/monitor',
      name: 'monitor',
      component: () => import('./views/ServerMonitor.vue'),
    },
  ],

  // linkActiveClass: 'active', // active class for non-exact links.
  linkExactActiveClass: 'active', // active class for *exact* links.
});


function parseQueryString(query: string) {
	const vars = query.split('&');
	const query_string: any = {};
	for (const val of vars) {
		const pair = val.split('=');
		const key = decodeURIComponent(pair[0]);
		const value = decodeURIComponent(pair[1]);
		// If first entry with this name
		if (typeof query_string[key] === 'undefined') {
			query_string[key] = decodeURIComponent(value);
			// If second entry with this name
		} else if (typeof query_string[key] === 'string') {
			const arr = [query_string[key], decodeURIComponent(value)];
			query_string[key] = arr;
			// If third or later entry with this name
		} else {
			query_string[key].push(decodeURIComponent(value));
		}
	}
	return query_string;
}

router.onError((error) => {
	console.error(error);
	if (/loading chunk \d* failed./i.test(error.message)) {
		window.location.reload();
	}
});

// beforeEnter navigation guard, afterEnter guard is dealed by App.vue and components
router.beforeEach((to, from, next) => {

	if (router.mode === 'hash') {
		const search = window.location.search.substring(1);
		if (search !== '') {
			const parsedParam = parseQueryString(window.location.search.substring(1));

			for (const key in parsedParam) {
				if (key === '') { continue; }
				to.query[key] = parsedParam[key];
			}

			let newSearch = '';
			const keys = Object.keys(to.query);
			for (let i = 0; i < keys.length; i++) {
				const key = keys[i];
				const value = to.query[key];
				if (i === 0) { newSearch += '?'; } else {newSearch += '&'; }
				newSearch += key + '=' + value;
			}
			const href = window.location.origin + '/#' + to.path + newSearch;
			console.log('url remade:' , href);
			window.location.href = href;
			return;
		}
	}

	const validation = navigationValidation(to, from);
	if (validation.success) {
		next();
	} else {
		if (validation.newRoute) {
			next(validation.newRoute);
		} else {
			next(false);
		}
	}
});
function prependSlash(list: string[]): string[] {
	const result: string[] = [];
	list.map((value) => {
		result.push(value, value + '/');
	});
	return result;
}
export const nonUserRelatedPath = prependSlash(['/auth']);

export function navigationValidation(to: Route, from?: Route): NavigationValidation {
	if (!from) { from = to; }
	// safe passage no matter login or not
	let allowedPaths = nonUserRelatedPath;
	if (allowedPaths.includes(to.path)) {
		return {success: true};
	}
	// end safe passage
	if (userx.loginStatus === 'loading') {
		return {success: true};
	} else {
		if (userx.loginStatus === 'logged out') {

			allowedPaths = prependSlash(['/login', '/register', '/forgot-password']);
			if (allowedPaths.includes(to.path)) {
				return {success: true};
			}
			const query = JSON.parse(JSON.stringify(from.query));
			query.continueUrl = to.fullPath;
			return {success: false, newRoute: {path: '/login', query, replace: true}};

		} else {
			// not allowed to
			if (to.path === '/login') {
				if (from.path === '/login') {
					return {success: false, newRoute: {path: '/', replace: false}};
				}
				return {success: false};
			}
			if (userx.needCompleteRegistration) {
				if (to.path === '/complete-registration') {
					return {success: true};
				} else {
					const query = JSON.parse(JSON.stringify(from.query));
					query.continueUrl = to.fullPath;
					return {success: false, newRoute: {path: '/complete-registration', query, replace: true}};
				}
			} else {
				if (to.path === '/complete-registration') {
					if (from.path === '/complete-registration') {
						return {success: false, newRoute: {path: '/', replace: false}};
					}
					return {success: false};
				}
				return {success: true};
			}
		}
	}
}
export default router;
